export default defineNuxtPlugin((nuxtApp) => {
  // Called on Suspense resolved event.
  nuxtApp.hook("page:finish", () => {
    nextTick().then(() => {
      window.scrollTo(0, 0);
    });
  });
});
